const filterTypes = {
    BEFORE: {
        value: "BEFORE",
        title: "↩",
        name: "Before"
    },
    AFTER: {
        value: "AFTER",
        title: "↪",
        name: "After"
    },
    LESS: {
        value: "LESS",
        title: "↘",
        name: "Less"
    },
    MORE: {
        value: "MORE",
        title: "↗",
        name: "More"
    },
    EQUALS: {
        value: "EQUALS",
        title: "=",
        name: "Equals"
    },
    LIKE: {
        value: "LIKE",
        title: "~",
        name: "Like"
    },
    IN: {
        value: "IN",
        title: "☑",
        name: "Including"
    },
    EXIST: {
        value: "EXIST",
        title: "∃",
        name: "Exist"
    },
    RANGE: {
        value: "RANGE",
        title: "⇔",
        name: "Date from-to"
    },
    BETWEEN: {
        value: "BETWEEN",
        title: "⇔",
        name: "Date between"
    },
    INTERVAL: {
        value: "INTERVAL",
        title: "⇔⇔",
        name: "Interval"
    },
};

export default filterTypes;



// WEBPACK FOOTER //
// ./src/data/filter-types.js